export default [
  {
    name: 'callback/kakao/token',
    path: '/callback/kakao/token',
    meta: {
      requireSignin: false,
      layout: 'EmptyLayout',
    },
    beforeEnter(to, from, next) {
      next()
    },
    component() {
      return import('@/pages/callback/kakao/Token.vue')
    },
  },
]
